import React, { useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import iconExcel from "../../assets/images/employee/iconExcel.svg";
import plus from "../../assets/images/product/plus.svg";
import TableCustomers from "./tableCustomers";
import { useCustomerList } from "../../hooks/useCustomer";
import toast from "react-hot-toast";
import useDebounce from "../../hooks/useDebounce";
import { customerCall } from "../../api/customer";
import { exportFile } from "../../utils/tools";
import { useCustomerUpdateRequestList } from "../../hooks/useCustomerUpdateRequest";

export default function CustomerUpdateRequest() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [employeeId, setEmployeeId] = useState(null);
  const [projectId, setProjectId] = useState(null);
  const [status, setStatus] = useState(null);
  const {
    customerListData,
    customerListExport,
    refetch,
    totalPages,
    setCurrentPage,
    isLoading,
    isRefetching,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useCustomerUpdateRequestList(
    debouncedSearch,
    projectId,
    employeeId,
    status
  );

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "",
      },
      {
        label: "Tên",
        key: "name",
      },
      {
        label: "Giới tính",
        key: "gender",
      },
      {
        label: "Trạng thái",
        key: "status",
      },
      {
        label: "Loại khách hàng",
        key: "isBusiness",
      },
      {
        label: "Mã số thuế",
        key: "businessTaxCode",
      },
      {
        label: "Ảnh ĐKKD của doanh nghiệp",
        key: "businessRegistrationImage",
      },
      {
        label: "Ngày sinh",
        key: "dateOfBirth",
      },
      {
        label: "SĐT&Email",
        key: "contact",
      },
      {
        label: "Loại giấy tờ tuỳ thân",
        key: "identityNumber",
      },
      {
        label: "CCCD/CMND hoặc Hộ chiếu",
        key: "identificationNumber",
      },
      {
        label: "Ngày cấp&N/c CCCD",
        key: "identificationInfo",
      },
      {
        label: "Ảnh CCCD mặt trước",
        key: "idCardFrontImage",
      },
      {
        label: "Ảnh CCCD mặt sau",
        key: "idCardBackImage",
      },
      {
        label: "Ảnh VNID",
        key: "vnidImage",
      },
      {
        label: "Đ/c thường trú",
        key: "permanentAddress",
      },
      {
        label: "Chỗ ở hiện tại",
        key: "currentAddress",
      },
      {
        label: "Nghề nghiệp",
        key: "career",
      },
      {
        label: "Dự án quan tâm",
        key: "project",
      },
      {
        label: "Nơi cấp ĐKDN",
        key: "businessRegistrationPlace",
      },
      {
        label: "Địa chỉ trên đăng ký KD",
        key: "businessAddress",
      },
      {
        label: "Địa chỉ văn phòng DN",
        key: "businessLocationAddress",
      },
      {
        label: "Ngày cấp ĐKKD",
        key: "businessRegistrationDate",
      },
      {
        label: "Người đại diện",
        key: "representativeName",
      },
      {
        label: "Giới tính NĐD",
        key: "representativeGender",
      },
      {
        label: "CCCD của NĐD",
        key: "representativeIdNumber",
      },
      {
        label: "Ngày cấp CCCD của NĐD",
        key: "representativeIdIssuedDate",
      },
      {
        label: "Nơi cấp CCCD của NĐD",
        key: "representativeIdIssuedPlace",
      },
      {
        label: "Ảnh CCCD mặt trước NĐD",
        key: "idRepresentativeCardFrontImage",
      },
      {
        label: "Ảnh CCCD mặt sau NĐD",
        key: "idRepresentativeCardBackImage",
      },
      {
        label: "Chức vụ NĐD",
        key: "representativePosition",
      },
      {
        label: "Phân loại",
        key: "type",
      },
      {
        label: "Nhân viên tạo",
        key: "employee",
      },
      {
        label: "Ngày tạo",
        key: "dateCreate",
      },
    ],
    data: customerListData,
  };
  // console.log({
  //   customerListData
  // });

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý phiếu chỉnh sửa khách hàng
          </Text>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableCustomers
          tableData={tableData}
          search={search}
          setSearch={setSearch}
          employeeId={employeeId}
          setEmployeeId={setEmployeeId}
          projectId={projectId}
          setProjectId={setProjectId}
          totalPages={totalPages}
          isLoading={isLoading}
          isRefetching={isRefetching}
          currentPage={currentPage}
          entries={entries}
          startEntry={startEntry}
          endEntry={endEntry}
          handlePageChange={handlePageChange}
          refetch={refetch}
          setStatus={setStatus}
        />
      </Box>
    </Box>
  );
}
